import React from 'react';
import { FaSortUp ,FaSortDown } from "react-icons/fa";

const SortableHeader = ({ column }) => {
  return (
    <div className="th-content">
      {column.render("Header")}
      <span className="sort-icon">
        {column.isSorted ? (
          column.isSortedDesc ? (
          <FaSortDown />
          ) : (          
           <FaSortUp />
          )
        ) : (
         ""
        )}
      </span>
    </div>
  );
};

export default SortableHeader;
